export default __webpack_public_path__ + "static/media/bottom.498e7e1b.svg";